export default __webpack_public_path__ + "static/lozenge-icon-do-light-cf4829d271b6404573049b3678519a61.png";